import styled, { keyframes, css } from 'styled-components'
import {
  mediaMax,
  calculateResponsiveSize,
  calculateMobileResponsiveSize
} from 'styles/media-queries'
import PassworRequestdIconImage from 'icons/logo_icon.svg'
import PassworRequestdLoginImage from 'icons/password_login.svg'
import EyeShowIcon from 'icons/ico_eye_show.png'
import EyeHideIcon from 'icons/ico_eye_hide.png'

const slideDownAndFadeOut = keyframes`
  from {
    transform: translateY(0);
    opacity: 1;
  }
  to {
    transform: translateY(100px);
    opacity: 0;
  }
`

export const PasswordRequestWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100svh;
  background: #BBA37A;  
`

export const PasswordRequestLogo = styled.div`
  width: ${calculateResponsiveSize(150)};
  height: ${calculateResponsiveSize(162)};
  margin: 0 0 ${calculateResponsiveSize(80)} 0;
  background: url(${PassworRequestdIconImage}) center center no-repeat;
  background-size: 100% auto;
  ${props => props.$isExiting && css`
    animation: ${slideDownAndFadeOut} 0.6s ease-out forwards;
  `}
  ${mediaMax('mobile')} {
    width: ${calculateMobileResponsiveSize(115)};
    height: ${calculateMobileResponsiveSize(125)};
    margin: 0 0 ${calculateMobileResponsiveSize(60)} 0;
  }
`

export const PasswordRequestInputWrapper = styled.div`
  width: ${calculateResponsiveSize(400)};
  margin: 0 0 ${calculateResponsiveSize(40)} 0;
  position: relative;
  ${props => props.$isExiting && css`
    animation: ${slideDownAndFadeOut} 0.6s ease-out forwards;
  `}
  ${mediaMax('mobile')} {
    width: ${calculateMobileResponsiveSize(276)};
    margin: 0 0 ${calculateMobileResponsiveSize(30)} 0;
  }
`

export const PasswordRequestInput = styled.input`
  width: 100%;
  height: ${calculateResponsiveSize(50)};
  padding: 0 ${calculateResponsiveSize(50)} 0 ${calculateResponsiveSize(15)};
  font-size: ${calculateResponsiveSize(16)};
  color: #ffffff;
  border-radius: 0;
  border: 1px solid #ffffff;
  background: none;
  outline: none;

  &::placeholder {
    color: #ffffff;
    opacity: 1;
  }
  &.error {
    border-color: #FF0C00;
    &::placeholder {
      color: #FF0C00;
    }
  }
  ${mediaMax('mobile')} {
    height: ${calculateMobileResponsiveSize(35)};
    padding: 0 ${calculateMobileResponsiveSize(40)} 0 ${calculateMobileResponsiveSize(10)};
    font-size: ${calculateMobileResponsiveSize(14)};
  }
`

export const PasswordRequestEye = styled.div`
  position: absolute;
  top: 50%;
  right: ${calculateResponsiveSize(20)};
  width: ${calculateResponsiveSize(20)};
  height: ${calculateResponsiveSize(20)};
  background: url(${props => props.$showPassword ? EyeHideIcon : EyeShowIcon}) center center no-repeat;
  background-size: 100% auto;
  transform: translateY(-50%);
  cursor: pointer;
  ${mediaMax('mobile')} {
    right: ${calculateMobileResponsiveSize(12)};
    width: ${calculateMobileResponsiveSize(20)};
    height: ${calculateMobileResponsiveSize(20)};
  }
`

export const PasswordRequestButton = styled.div`
  padding: 0 ${calculateResponsiveSize(26)} 0 0;
  font-size: ${calculateResponsiveSize(16)};
  color: #ffffff;
  white-space: nowrap;
  position: relative;
  cursor: pointer;
  ${props => props.$isExiting && css`
    animation: ${slideDownAndFadeOut} 0.6s ease-out forwards;
  `}
  &::before {
    position: absolute;
    top: 50%;
    right: 0;
    content: '';
    width: ${calculateResponsiveSize(12)};
    height: ${calculateResponsiveSize(25)};
    background: url(${PassworRequestdLoginImage}) center center no-repeat;
    background-size: 100% auto;
    transform: translateY(-50%);
  }
  ${mediaMax('mobile')} {
    padding: 0 ${calculateMobileResponsiveSize(20)} 0 0;
    font-size: ${calculateMobileResponsiveSize(14)};
    &::before {
      top: calc(50% - ${calculateMobileResponsiveSize(1)});
      width: ${calculateMobileResponsiveSize(9)};
      height: ${calculateMobileResponsiveSize(18)};
    }
  }
`
